import Vue from 'vue'
import LedgerConfigPageTemplate from "@/extend/LedgerConfig/LedgerConfigPageTemplate.vue";

export const isLedgerConfigMenu = (menu) => {
    return menu && menu.formId && Number(menu.formId)
}
export const setLedgerConfigForUser = (includeLedgerConfigMenu) => {
    let user = window.sessionStorage.getItem('biz_admin')
    if (user) {
        user = JSON.parse(window.sessionStorage.getItem('biz_admin'))
        window.sessionStorage.setItem('biz_admin', JSON.stringify({ ...user, includeLedgerConfigMenu }))
        // 创建用户缓存供动态台账子系统使用
        window.sessionStorage.setItem('biz_admin', JSON.stringify({ ...user, includeLedgerConfigMenu }))
    }
}

const ledgerConfigTemplate = menu => {
    const name = menu.address
    const component = {
        ...LedgerConfigPageTemplate,
        name,
        data() {
            return { formId: menu.formId, microAppName: menu.address }
        }
    }
    return component
}

export const ledgerConfigMenuTreeResolve = (menuTree) => { // 从用户授权菜单树中获取动态菜单项
    let ledgerMenus = []
    let excludeMenusAddress = []
    menuTree.forEach((menu) => {
        if (isLedgerConfigMenu(menu))  {
            ledgerMenus.push(menu)
            excludeMenusAddress.push(menu.address)
        }
        if (menu.children) {
            menu.children.forEach((subMenu) => {
                if (isLedgerConfigMenu(subMenu))  {
                    ledgerMenus.push(subMenu)
                    excludeMenusAddress.push(subMenu.address)
                }
            })
        }
    })
    Vue.store.commit('LedgerConfig/ledgerConfigMenus', ledgerMenus)
    Vue.store.commit('LedgerConfig/ledgerConfigExcludeMenus', excludeMenusAddress)
    setLedgerConfigForUser(ledgerMenus.length > 0)
    return { ledgerMenus, excludeMenusAddress }
}

export const getLedgerConfigRoutes = (menuTree) => { // 返回路由注册信息数组，需要添加到当前主页子路由children下面 (系统使用路由时使用)
    const { ledgerMenus} = ledgerConfigMenuTreeResolve(menuTree)
    const routes = []
    ledgerMenus.forEach(menu => {
        const component = ledgerConfigTemplate(menu)
        routes.push({path: component.name, name: component.name, component})
    })
    return routes
}

export const ledgerConfigComponentsRedirectRoute = () => { // 动态组件模式下，微服务的路由会导致空路由清空，默认添加对应的微服务路由重定向到'/'
    Vue.router.addRoute({ path: '/ledger-form-page', redirect: '/' })
}

export const getLedgerConfigComponents = (menuTree) => { // 返回组件数组供组件注册使用 (系统使用动态组件时使用)
    const { ledgerMenus} = ledgerConfigMenuTreeResolve(menuTree)
    const components = []
    ledgerMenus.forEach(menu => components.push(ledgerConfigTemplate(menu)))
    return components
}


export const registerLedgerConfigComponents = (menuTree) => { // 使用动态组件时，传递菜单树结构，直接注册
    const { ledgerMenus} = ledgerConfigMenuTreeResolve(menuTree)
    ledgerMenus.forEach(menu => {
        const component = ledgerConfigTemplate(menu)
        Vue.component(component.name, component)
    })
    ledgerConfigComponentsRedirectRoute()
}

